import {
  ITranslationMap,
  type ICustomMappingSourceOption,
} from '@principle-theorem/practice-migrations/interfaces';
import { type IManualTransactionType } from '@principle-theorem/principle-core/interfaces';
import {
  isSameRef,
  type AtLeast,
  type INamedDocument,
  type IXSLXExport,
  type XSLXCell,
} from '@principle-theorem/shared';
import type { Column } from 'exceljs';

export interface IPayorLabelXSLX {
  sourceId: string;
  sourceName: string;
  mapTo: string;
}

export const PAYOR_LABEL_HEADERS: AtLeast<Column, 'key' | 'header'>[] = [
  {
    key: 'sourceId',
    header: 'Payor ID',
  },
  {
    key: 'sourceName',
    header: 'Payor Name',
    width: 45,
  },
  {
    key: 'mapTo',
    header: 'Manual Transaction Type',
    width: 30,
  },
];

export class PayorLabelToXSLX
  implements IXSLXExport<ICustomMappingSourceOption, IPayorLabelXSLX>
{
  headers = PAYOR_LABEL_HEADERS;

  constructor(
    private _manualTypes: INamedDocument<IManualTransactionType>[],
    private _existingMappings: ITranslationMap<IManualTransactionType>[]
  ) {}

  translate(
    records: ICustomMappingSourceOption[]
  ): Record<keyof IPayorLabelXSLX, XSLXCell>[] {
    return records.map((record) => {
      const existingRecord = this._existingMappings.find(
        (existing) => existing.sourceIdentifier === record.value
      );

      const destinationIdentifier = existingRecord?.destinationIdentifier;
      const mappedType = destinationIdentifier
        ? this._manualTypes.find((type) =>
            isSameRef(type, destinationIdentifier)
          )
        : undefined;

      return {
        sourceId: {
          value: record.value,
        },
        sourceName: {
          value: record.label,
        },
        mapTo: {
          value: mappedType?.name,
          dataValidation: {
            type: 'list',
            formulae: [
              `"${this._manualTypes.map((type) => type.name).join(',')}"`,
            ],
          },
        },
      };
    });
  }
}
